import { Theme, ThemeOptions, createTheme } from '@material-ui/core/styles';

declare module "@material-ui/core/styles" {

  interface PaletteColorOptions {
    main? : string;
    contrastText?: string;
    blue?: string;
    copy?: string;
    graph?: string;
  }
}
declare module "@material-ui/core/styles/createPalette" {
  interface TypeBackground {
    default: string;
    paper: string;
    main: string;
  }
  interface PaletteColor 
  {
    light: string;
    main: string;
    dark: string;
    contrastText: string;
    blue: string;
  }
}

const themeOptions: ThemeOptions  = 
  {
    palette: {
        primary: {
          main: '#566db3',
          contrastText: "#fff",
          copy: '#58595b',
          blue: 'rgba(28,172,232,.2)',
          graph: 'rgba(86,109,179,.6)',
        },
        secondary: {
          main: '#ed7044',
        },
        background:{
          main: '#E7E7E7'
        },
        error:{
          main: '#ed7044'
        }
      },
};


const theme: Theme = createTheme(themeOptions);
export default theme;